@if (showDialog) {
<div>
  <div class="game-over-overlay"></div>
  <div class="god_off">
    <div class="game-over-cont" [class.game-over-animation]="showDialog">
      <div class="game-over-header">{{ announceTitle }}</div>
      <div text-left class="game-over-details-cont">
        <div text-center>
          {{ announceContent }}
          <br />
          <br />
          <div text-center>
            <ion-row class="row-wrap">
              <ion-col col-6="">
                <div text-center class="sign-up-button" padding>
                  @if (closeAvailable) {
                  <ion-button
                    (click)="closeDialog()"
                    expand="block"
                    class="submit-button cancel-background"
                    >No</ion-button
                  >
                  }
                </div>
              </ion-col>
              <ion-col col-6="">
                <div text-center class="sign-up-button" padding>
                  @if (buttonAvailable) {
                  <ion-button
                    (click)="gotoPage()"
                    expand="block"
                    class="submit-button"
                    >{{ buttonString }}</ion-button
                  >
                  }
                </div>
              </ion-col>
            </ion-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
}
